import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpXsrfTokenExtractor } from "@angular/common/http";
import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";


// @Injectable()
// export class XsrfInterceptor implements HttpInterceptor {
//   constructor(private xsrfTokenExtractor: HttpXsrfTokenExtractor) {
//   }

//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     // load token
//     let xsrfToken = this.xsrfTokenExtractor.getToken();

//     if (xsrfToken != null) {
//       // create a copy of the request and
//       // append the XSRF token to the headers list
//       const authorizedRequest = req.clone({
//         withCredentials: true,
//         headers: req.headers.set('X-XSRF-TOKEN', xsrfToken)
//       });


//       console.log('------ added token ');
//       return next.handle(authorizedRequest);
//     } else {
//       console.log(' --------- token not found ');
//       return next.handle(req);
//     }
//   }
// }

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cookieheaderName = 'X-XSRF-TOKEN';
    let csrfToken = this.tokenExtractor.getToken() as string;
    if (csrfToken !== null && !req.headers.has(cookieheaderName)) {
      req = req.clone({ headers: req.headers.set(cookieheaderName, csrfToken) });
    }

    req.headers.set("X-Frame-Options", "SAMEORIGIN");
       
    return next.handle(req);
  }
}
